export default function AccountsRepo($http, appSettings, initialData) {
	'ngInject';

	const _currentAccount = (initialData.currentUser || {}).account;
	const _userAccounts = initialData.userAccounts;

	return {
		getCurrentAccount: function() {
			return _currentAccount || {};
		},
		getAccounts: function() {
			return _userAccounts || [];
		},
		getSubAccounts: function() {
			const currentAccount = this.getAccounts().find(acc => acc.accountId === this.getCurrentAccount().id) || {};
			return currentAccount.subAccounts;
		},
		createSubAccount: function(accountName) {
			const endpoint = `${appSettings.InReachApiEndpoint}/accounts`;
			return $http.post(endpoint, accountName);
		},
		updateSubAccountName: function(accountName) {
			const endpoint = `${appSettings.InReachApiEndpoint}/accounts`;
			return $http.put(endpoint, accountName);
		},
		signInTo: function(account) {
			const endpoint = `${appSettings.InReachApiEndpoint}/accounts`;
			return $http.get(endpoint);
		}
	};
}
